import { AxiosError } from "axios";
import { apiClientes } from "../config/api";
import { getTokenClientes } from "../Store/storages/AuthenticationStorage";
import { AvaliacaoEspacoPersonal } from "../interfaces/entities/SaudeOnline/AvaliacaoEspacoPersonal";

export const getAvaliacao = async (): Promise<AvaliacaoEspacoPersonal> => {
    try {
        const Authorization = `Bearer ${await getTokenClientes()}`;
        const headers = { Authorization };
        const response = await apiClientes.get("/Beneficiario/GetAvaliacao", { headers });
        return response.data;
    } catch (error) {
        throw (error as AxiosError)?.response?.data;
    }
};